import { render, staticRenderFns } from "./noticias.vue?vue&type=template&id=05f4bdfe&scoped=true&"
import script from "./noticias.ts?vue&type=script&lang=ts&"
export * from "./noticias.ts?vue&type=script&lang=ts&"
import style0 from "./noticias.vue?vue&type=style&index=0&id=05f4bdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4bdfe",
  null
  
)

export default component.exports